import card1 from "../assets/img/Card1.png";
import estampaCard1 from "../assets/img/Estampa_Card1.png";
import card2 from "../assets/img/Card2.png";
import estampaCard2 from "../assets/img/Estampa_Card2.png";
import card3 from "../assets/img/Card3.png";
import estampaCard3 from "../assets/img/Estampa_Card3.png";
import card4 from "../assets/img/Card4.png";
import estampaCard4 from "../assets/img/Estampa_Card4.png";
import card5 from "../assets/img/Card5.png";
import estampaCard5 from "../assets/img/Estampa_Card5.png";
import card6 from "../assets/img/Card6.png";
import estampaCard6 from "../assets/img/Estampa_Card6.png";
import card7 from "../assets/img/Card7.png";
import estampaCard7 from "../assets/img/Estampa_Card7.png";
import card8 from "../assets/img/Card8.png";
import estampaCard8 from "../assets/img/Estampa_Card8.png";

const cards = [
  {
    id: 1,
    fotoProduto: card1,
    fotoEstampa: estampaCard1,
    descricao: "Astronauta Triangulo",
    preco: 80,
  },
  {
    id: 2,
    fotoProduto: card2,
    fotoEstampa: estampaCard2,
    descricao: "Astronauta Balão",
    preco: 81,
  },
  {
    id: 3,
    fotoProduto: card3,
    fotoEstampa: estampaCard3,
    descricao: "Astronauta Azul",
    preco: 82,
  },
  {
    id: 4,
    fotoProduto: card4,
    fotoEstampa: estampaCard4,
    descricao: "Astronauta Portal",
    preco: 83,
  },
  {
    id: 5,
    fotoProduto: card5,
    fotoEstampa: estampaCard5,
    descricao: "Planeta Fatiado",
    preco: 84,
  },
  {
    id: 6,
    fotoProduto: card6,
    fotoEstampa: estampaCard6,
    descricao: "Astronauta Balanço",
    preco: 85,
  },
  {
    id: 7,
    fotoProduto: card7,
    fotoEstampa: estampaCard7,
    descricao: "Gatonauta",
    preco: 86,
  },
  {
    id: 8,
    fotoProduto: card8,
    fotoEstampa: estampaCard8,
    descricao: "Astronauta Skate",
    preco: 87,
  },
];

export default cards;
